<template>
  <CustomDialog
    :dialog-title="titleText"
    title-icon-class="text-lg mr-3"
    title-class="items-center"
    button-color="success-500"
    :has-footer="false"
    :has-exit-button="true"
    max-width="30rem"
    min-width="30rem"
    data-target="privacy-respected-dialog"
    footer-custom-class="!p-0 border-t border-slate-200"
    :body-custom-style="{ padding: '0px' }"
    @cancel="emit('closeDialog')"
  >
    <template #titleIcon>
      <Icon
        name="material-symbols:check-circle-outline"
        size="1.5rem"
        class="text-success-500 mr-3"
      />
    </template>
    <div class="flex flex-col px-5">
      <div class="py-6 flex flex-col gap-4">
        <p class="text-slate-600 text-sm font-medium leading-5">
          {{ descriptionText }}
        </p>
        <div
          class="p-4 border border-slate-200 rounded flex flex-row items-start gap-4 bg-slate-50"
        >
          <div
            class="w-9 h-9 rounded-full bg-secondary-200 flex-shrink-0 flex items-center justify-center"
          >
            <Icon
              name="material-symbols:mail-outline"
              size="1rem"
              class="text-secondary-600"
            />
          </div>
          <div class="flex flex-col gap-1 w-full text-left">
            <h3 class="text-slate-900 text-sm font-semibold">
              {{ supportBoxTitleText }}
            </h3>
            <a
              :href="`mailto:${supportBoxEmailText}`"
              class="text-secondary-600 text-sm font-medium focus:outline-none hover:text-secondary-700 transition-colors w-fit"
              >{{ supportBoxEmailText }}</a
            >
            <p class="text-slate-500 text-sm font-medium leading-5">
              {{ supportBoxSubtitleText }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <template #footer>
      <div class="w-full flex items-center justify-end px-5 py-4">
        <PrimaryButton
          variant="outline-secondary-neutral"
          custom-class="font-semibold"
          @on-click="emit('closeDialog')"
        >
          {{ closeBtnText }}
        </PrimaryButton>
      </div>
    </template>
  </CustomDialog>
</template>
<script setup lang="ts">
import CustomDialog from "~/components/shared/custom-dialog/CustomDialog.vue";
import PrimaryButton from "~/components/shared/primary-button/PrimaryButton.vue";
defineProps<{
  titleText: string;
  descriptionText: string;
  supportBoxTitleText: string;
  supportBoxEmailText: string;
  supportBoxSubtitleText: string;
  closeBtnText: string;
}>();
const emit = defineEmits<{
  closeDialog: [];
}>();
</script>
